import { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { PenLine, Upload, Trash2, X } from "lucide-react";
import { useState } from "react";
import { trimCanvas } from "./FirmaGraficaDialog";

// Campo firma: mostra "FIRMA NON PRESENTE" oppure l'anteprima; apre un pad per disegnare o caricare un'immagine.
export default function SignatureField({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const padRef = useRef(null);
  const fileRef = useRef(null);
  const boxRef = useRef(null);
  const [padW, setPadW] = useState(0);
  useEffect(() => {
    if (!open) { setPadW(0); return; }
    let ro;
    const t = setTimeout(() => {
      const el = boxRef.current;
      if (!el) return;
      const fit = () => setPadW(Math.floor(el.clientWidth));
      fit();
      ro = new ResizeObserver(fit);
      ro.observe(el);
    }, 50);
    return () => { clearTimeout(t); if (ro) ro.disconnect(); };
  }, [open]);

  const confirmDraw = () => {
    if (padRef.current && !padRef.current.isEmpty()) {
      onChange(trimCanvas(padRef.current.getCanvas()).toDataURL("image/png"));
    }
    setOpen(false);
  };
  const clearPad = () => padRef.current && padRef.current.clear();
  const onUpload = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    const r = new FileReader();
    r.onload = () => { onChange(r.result); setOpen(false); };
    r.readAsDataURL(f);
  };

  return (
    <>
      <div className="mt-1.5 flex items-center gap-2">
        {value ? (
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <img src={value} alt="firma" className="h-12 w-auto max-w-[180px] bg-white rounded border border-slate-700 object-contain" data-testid={`${testId}-preview`} />
            <button type="button" onClick={() => onChange("")} data-testid={`${testId}-remove`} title="Rimuovi firma"
              className="shrink-0 h-8 w-8 flex items-center justify-center rounded-md border border-red-500/30 text-red-400 hover:bg-red-500/10">
              <X className="h-4 w-4" />
            </button>
          </div>
        ) : (
          <span className="flex-1 text-xs font-mono tracking-wide text-slate-500">FIRMA NON PRESENTE</span>
        )}
        <button type="button" onClick={() => setOpen(true)} data-testid={`${testId}-add`} title="Aggiungi firma"
          className="shrink-0 h-9 w-9 flex items-center justify-center rounded-md border border-slate-700 bg-slate-800/60 text-slate-100 hover:text-amber-400 hover:border-amber-500/40">
          <PenLine className="h-4 w-4" />
        </button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-md" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle className="font-head flex items-center gap-2"><PenLine className="h-5 w-5 text-amber-400" /> Firma cliente</DialogTitle></DialogHeader>
          <div ref={boxRef} className="rounded-lg bg-white overflow-hidden border border-slate-300" style={{ height: 180 }}>
            {padW > 0 && (
              <SignatureCanvas key={padW} ref={padRef} penColor="#111827"
                canvasProps={{ width: padW, height: 180, style: { width: padW, height: 180, display: "block", touchAction: "none" }, "data-testid": `${testId}-pad` }} />
            )}
          </div>
          <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={onUpload} data-testid={`${testId}-file`} />
          <DialogFooter className="flex flex-wrap gap-2 sm:justify-between">
            <div className="flex gap-2">
              <Button type="button" variant="outline" onClick={clearPad} className="h-9 border-slate-700 text-slate-200 hover:bg-slate-800"><Trash2 className="h-4 w-4 mr-1" /> Pulisci</Button>
              <Button type="button" variant="outline" onClick={() => fileRef.current && fileRef.current.click()} className="h-9 border-slate-700 text-slate-200 hover:bg-slate-800"><Upload className="h-4 w-4 mr-1" /> Carica immagine</Button>
            </div>
            <Button type="button" onClick={confirmDraw} data-testid={`${testId}-confirm`} className="h-9 bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">Salva firma</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
